import { render, staticRenderFns } from "./filter-confirm-close.vue?vue&type=template&id=47670893&"
import script from "./filter-confirm-close.vue?vue&type=script&lang=js&"
export * from "./filter-confirm-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports